__turbopack_context__.v({
  "leftPanel": "BottomBar-module__n_URDq__leftPanel",
  "midPanel": "BottomBar-module__n_URDq__midPanel",
  "midPanelPhone": "BottomBar-module__n_URDq__midPanelPhone",
  "rightPanel": "BottomBar-module__n_URDq__rightPanel",
});
